import { User } from "@/apis/bff"
import { canUserTakeAppointmentWithService } from "@/lib/can-user-take-appointment-with-service"
import {
  CancelTeleconsultationAppointmentActionItem,
  DeleteTeleconsultationAppointmentActionItem,
  EditAppointmentActionItem,
  OpenDrawerAppointmentActionItem,
  TakeConsultationAppointmentActionItem,
} from "@/modules/patients/agenda/teleconsultation/appointment-action-menu/appointment-action-menu-item"
import { AppointmentAgenda } from "@/modules/patients/libs/categorize-date-ranges"
type PlannedAppointmentActionMenuProps = {
  isEditMode: boolean
  rowData: AppointmentAgenda
  user: User
  onClickEdit: React.MouseEventHandler<HTMLDivElement>
  onClickOpenDrawer: React.MouseEventHandler<HTMLDivElement>
  onClickCancelTeleconsultation: React.MouseEventHandler<HTMLDivElement>
  onClickDeleteTeleconsultation: React.MouseEventHandler<HTMLDivElement>
  onClickTakeConsultation: React.MouseEventHandler<HTMLDivElement>
}

export const PlannedAppointmentActionMenu = ({
  isEditMode,
  rowData,
  user,
  onClickEdit,
  onClickOpenDrawer,
  onClickCancelTeleconsultation,
  onClickDeleteTeleconsultation,
  onClickTakeConsultation,
}: PlannedAppointmentActionMenuProps) => {
  const canTakeConsultation = canUserTakeAppointmentWithService(user, rowData.service)

  return isEditMode ? (
    <>
      <EditAppointmentActionItem onClick={onClickEdit} />
      <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
      <CancelTeleconsultationAppointmentActionItem onClick={onClickCancelTeleconsultation} />
      <DeleteTeleconsultationAppointmentActionItem onClick={onClickDeleteTeleconsultation} />
      {canTakeConsultation && <TakeConsultationAppointmentActionItem onClick={onClickTakeConsultation} />}
    </>
  ) : (
    <OpenDrawerAppointmentActionItem onClick={onClickOpenDrawer} />
  )
}
